import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Seo from "../../components/Seo";
import { NavLink } from "react-router-dom";
import localeImage from "../../assets/images/pizzeria-interno.jpeg";
import pizzaImage from "../../assets/images/pizza-cx.jpeg";
import "./About.css";

export default function About() {
    return (
        <>
            <Seo
                title="Chi siamo | Busca Vida Pizzeria Cecina"
                description="Conosci Busca Vida, pizzeria e cucina italiana a Cecina: pizza croccante, impasti leggeri, piatti di mare e un locale accogliente."
                path="/chi-siamo"
            />
            <Navbar />
            <main className="about-page">
                <header className="about-hero">
                    <div className="about-hero-overlay" />
                    <div className="about-hero-content">
                        <p>Busca Vida · Cecina</p>
                        <h1>Chi siamo</h1>
                        <span>Pizza, cucina e voglia di stare bene insieme.</span>
                    </div>
                </header>

                <section className="about-story container">
                    <div className="about-story-copy">
                        <p className="about-kicker">La nostra identità</p>
                        <h2>Il gusto semplice delle cose fatte con cura</h2>
                        <p>
                            Busca Vida è una pizzeria e cucina italiana nel cuore di Cecina.
                            La nostra proposta parte dalla pizza croccante, dall’impasto
                            leggero e dal forno rovente, per arrivare a schiacciatini,
                            antipasti, primi, secondi e specialità di mare.
                        </p>
                        <p>
                            Cerchiamo sapori riconoscibili, abbinamenti generosi e
                            un’atmosfera informale in cui ritrovarsi per una cena, una
                            pizza tra amici o una serata in famiglia.
                        </p>
                    </div>
                    <figure className="about-story-image">
                        <img src={localeImage} alt="La sala di Busca Vida Pizzeria a Cecina" />
                    </figure>
                </section>

                <section className="about-values">
                    <div className="container about-values-grid">
                        <article>
                            <span>01</span>
                            <h3>Impasto leggero</h3>
                            <p>Una pizza croccante, pensata per essere gustosa e piacevole.</p>
                        </article>
                        <article>
                            <span>02</span>
                            <h3>Menu per tutti</h3>
                            <p>Dalla pizzeria alla cucina, con proposte di carne, pesce e vegetariane.</p>
                        </article>
                        <article>
                            <span>03</span>
                            <h3>Ospitalità</h3>
                            <p>Un ambiente accogliente e diretto, dove sentirsi a proprio agio.</p>
                        </article>
                    </div>
                </section>

                <section className="about-feature container">
                    <img src={pizzaImage} alt="Pizza preparata da Busca Vida a Cecina" />
                    <div>
                        <p className="about-kicker">A tavola</p>
                        <h2>Scopri cosa prepariamo</h2>
                        <p>
                            Classiche, speciali, schiacciatini e piatti di cucina:
                            consulta il menu aggiornato e scegli il tuo prossimo assaggio.
                        </p>
                        <div className="about-actions">
                            <NavLink to="/menu">Vedi il menu</NavLink>
                            <a href="tel:+393513478565">Prenota un tavolo</a>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}

